import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

@Injectable({
  providedIn: 'root',
})
export class ExportService {
  constructor(private http: HttpClient) {}

  export(url: string, filename: string): void {
    this.http
      .get(url, {
        responseType: 'blob',
      })
      .subscribe({
        next: (file: Blob) => {
          this.download(file, filename);
        },
        error: (error) => {
          console.error('Export failed:', error);
        },
      });
  }

  private download(file: Blob, filename: string): void {
    const url = URL.createObjectURL(file);

    const anchor = document.createElement('a');

    anchor.href = url;
    anchor.download = filename;

    document.body.appendChild(anchor);

    anchor.click();

    anchor.remove();

    URL.revokeObjectURL(url);
  }
}

// protected exportPdf(): void {
//
//   this.exportService.export(
//     `${ApiEndpoints.url}/class/${this.classId}/students/export/pdf`,
//     'students.pdf'
//   );
// }
